import { get } from "api/helper";
import { Language, LanguageOption } from "interfaces/locale";
import { ApiLanguageData } from "./interfaces";

export const getLanguages = async (
  lang: Language
): Promise<Array<LanguageOption>> => {
  const { data } = await get<ApiLanguageData>("v1/languages", {
    lang,
  });

  return (
    data?.items.map((language) => ({
      label: language.language,
      value: language.code,
    })) || []
  );
};
